window.openSLForCard = function (btn) {
  var card = btn.closest('.product-card') || btn.closest('.klevuProduct');
  if (!card) return;

  var handle = null, variantId = null;
  var jsonEl = card.querySelector('[data-swatches-json]');

  if (jsonEl) {
    var active = card.querySelector('.product-swatches__item--active')
              || card.querySelector('[data-swatch-item]');     // fallback ô đầu
    if (active) {
      handle = active.dataset.swatchItem;
      var entry = JSON.parse(jsonEl.textContent)[handle];
      if (entry && entry.variants && entry.variants.length) {
        var priceEl = card.querySelector('.product-card__price');
        var m = priceEl && priceEl.textContent.match(/\/\s*([A-Za-z]+)\s*$/);
        var unit = m ? m[1].toUpperCase() : null;
        var v = (unit && entry.variants.find(function (x) { return (x.option3 || '').toUpperCase() === unit; }))
             || entry.variants[0];
        variantId = v.id;
      }
    }
  }

  // Card không swatch / Klevu: handle từ link product, variantId từ data-id (Klevu)
  if (!handle) {
    var link = card.querySelector('a[href*="/products/"]');
    handle = link ? link.getAttribute('href').split('/products/')[1].split(/[?#]/)[0] : null;
  }
  if (!variantId) variantId = card.getAttribute('data-id');

  if (!handle) return;

  if (window._Duos && typeof window._Duos.openShoppingListModal === 'function') {
    window._Duos.openShoppingListModal({ productHandle: handle, variantId: variantId, quantity: 1 });
  }
};